import React from 'react';
import TriangleDownIcon from './CustomIcons/TriangleDownIcon';
import TriangleRightIcon from './CustomIcons/TriangleRightIcon';

export interface DisclosureArrowProps {
    /** Whether the disclosure is open (renders the down triangle vs. the right one). */
    expanded: boolean;
    size?: number;
    className?: string;
}

/**
 * The expand/collapse triangle used by disclosure UI (Accordion, expandable rows).
 * Owns its colour states so they never drift between usages: dark
 * (`text-primary`) when expanded, muted (`text-placeholder`) otherwise, and dark on
 * hover when placed inside a `group` ancestor. Put `group` on the clickable
 * header/row so the hover state activates.
 */
const DisclosureArrow: React.FC<DisclosureArrowProps> = ({
    expanded,
    size = 11,
    className = '',
}) => {
    const colour = expanded
        ? 'text-[var(--malachite-text-primary)]'
        : 'text-[var(--malachite-text-placeholder)] group-hover:text-[var(--malachite-text-primary)]';

    return (
        <span
            aria-hidden="true"
            className={`shrink-0 flex items-center transition-colors ${colour} ${className}`}
        >
            {expanded ? (
                <TriangleDownIcon size={size} />
            ) : (
                <TriangleRightIcon size={size} />
            )}
        </span>
    );
};

export default DisclosureArrow;
export { DisclosureArrow };
